module.exports = __webpack_public_path__ + "img/UOI3208.7ce0bbce.png";